import { Box } from "@mui/material";
import { V2Shell } from "@/v2/components/V2Shell";
import { Footer as V2Footer } from "@/v2/components/Footer";

/**
 * v1 pages that keep their v1 content but pick up the v2 nav (config.v2.nav)
 * still need a footer - MainContainer and PublicRoute's useV2Nav branch
 * renders this instead of raw children, since without it those pages lost
 * the footer entirely (v2-native pages supply their own via
 * SidebarLegalFooter instead, via useV2Layout, which bypasses both).
 * flexGrow on the children wrapper pushes the footer to the bottom of the
 * scrollable viewport when the page content is shorter than the screen,
 * instead of leaving it floating above a gap of empty space.
 *
 * Every v1 page renders the redesigned v2 Footer now (wrapped in its own
 * V2Shell, since this file is v1 and has none); the old v1 Footer it used to
 * fall back to has been retired.
 */
export function StickyFooterShell({
  children,
  hideFooter = false,
}: {
  children: React.ReactNode;
  hideFooter?: boolean;
}) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
      {hideFooter ? null : (
        <V2Shell>
          <V2Footer />
        </V2Shell>
      )}
    </Box>
  );
}
